module.exports = __webpack_public_path__ + "static/media/londis.993515a8.png";